import { React, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import Buttons from '../button/index.js';
import SignIn from './modalfields/signin.js';
import SignUp from './modalfields/signup.js'
import Cookies from 'universal-cookie';
import { getCustomer } from '../../api'
import ContactModal from '../contactmodal/index.js';
export default function Modale(props) {
    const cookie = new Cookies()
    const [message, setMessage] = useState('')
    const [SupportModalShow, setSupportModalShow] = useState(false);


    useEffect(async () => {
        if (cookie.get('id')) {
            const user = getCustomer(cookie.get('id'))
            user.then(response => {
                setMessage(response.data.message)
            })
        }
    }, [])

    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            {
                props.signin === true ?
                    <>
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <h3>Sign In</h3>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <SignIn />
                        </Modal.Body>

                    </>
                    : props.signin === false ?
                        <>
                            <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title-vcenter">
                                    {
                                        SupportModalShow ? <h3>Contact Support</h3> : <h3>Sign Up</h3>
                                    }
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <SignUp Close={props.onHide} setModalShow={props.setModalShow} SupportModalShow={SupportModalShow} setSupportModalShow={setSupportModalShow} />
                            </Modal.Body>

                        </>
                        :
                        <>
                            <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title-vcenter">
                                    <h3>Warning</h3>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {
                                    SupportModalShow ?
                                        <ContactModal Close={props.onHide} setSupportModalShow={setSupportModalShow} />
                                        :
                                        <>
                                            <h5>
                                                {message}
                                            </h5>
                                            <br></br>
                                            <Button variant='primary' onClick={() => setSupportModalShow(true)}>
                                                Contact Us
                                            </Button>
                                        </>
                                }
                            </Modal.Body>
                        </>
            }
        </Modal>
    )
}
